import { RouteReuseStrategy } from '@angular/router/';
import { ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
import { TabService } from 'src/app/services/tab.service';
import { Injectable } from '@angular/core';


@Injectable()
export class CacheRouteReuseStrategy implements RouteReuseStrategy {

    constructor(private tabServices:TabService){
        
    }

    storedRouteHandles = new Map<string, DetachedRouteHandle>();
    
    shouldReuseRoute(before: ActivatedRouteSnapshot, curr:  ActivatedRouteSnapshot): boolean {
        return before.routeConfig === curr.routeConfig;
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        return this.storedRouteHandles.get(this.getPath(route)) as DetachedRouteHandle;
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return !!route.routeConfig && !!this.storedRouteHandles.has(this.getPath(route));
    }

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        const path = this.getPath(route);

        if ( this.tabServices.tabs.findIndex(d=>d.url == path )>-1){
            return true;
        }else{
            this.storedRouteHandles.delete(path);
            return false;
        }
        
    }

    store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {

        if ( this.getPath(route) == "" || this.getPath(route) == "changepassword" || this.getPath(route)=="auth"){
            if ( this.getPath(route)=="auth" ){
                this.storedRouteHandles.clear();
            }
              return;
        }


        const path = this.getPath(route);
        if ( !this.storedRouteHandles.has(path)){
            this.storedRouteHandles.set(this.getPath(route), detachedTree);
        }
    }

    private getPath(route: ActivatedRouteSnapshot): string {
        if (route.routeConfig !== null && route.routeConfig.path !== null) {
            return route.routeConfig.path;
        }
        return '';
    }
}